import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { KNOWLEDGE_BASE_INSTALL_MOBILE_APP_ARTICLE_URL } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export const SERVICE_EVALUATION_CARD_NAME = 'service-evaluation';
export const getServiceEvaluationModalSteps = (capitalizedTier = 'Free') => [{
  illustration: 'service-free',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `setup-guide-components.modal.serviceEvaluation.whatIsServiceHub.title${capitalizedTier}`
  }),
  description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      Link: KnowledgeBaseButton
    },
    message: `setup-guide-components.modal.serviceEvaluation.whatIsServiceHub.body${capitalizedTier}_jsx`,
    options: {
      url: KNOWLEDGE_BASE_INSTALL_MOBILE_APP_ARTICLE_URL
    }
  })
}, {
  illustration: 'conversations-inbox',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.intake.title"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.intake.body"
  })
}, {
  illustration: 'tickets',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.triage.title"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.triage.body"
  })
}, {
  illustration: 'flowing-conversations',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.troubleshoot.title"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `setup-guide-components.modal.serviceEvaluation.troubleshoot.body${capitalizedTier}`
  })
}, {
  illustration: 'successfully-submitted-question',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.solve.title"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.solve.body"
  })
}, {
  illustration: 'add-on-reporting',
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.improve.title"
  }),
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "setup-guide-components.modal.serviceEvaluation.improve.body"
  })
}];